import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SearchEventService } from './search-event.service';
import { AnalyticsData, AnalyticsService } from '@icullen/api/shared';

@Component({
  selector: 'icullen-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
  @Input() isMobile = false;
  uniqueNumberRegexp: RegExp = /[a-zA-Z5]{6}\d{8}/;

  constructor(
    public searchEventService: SearchEventService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  searchDocuments(query: string) {
    if (this.uniqueNumberRegexp.test(query)) {
      this.router.navigate(['/site/documents/' + query.trim()]);
    } else {
      this.searchEventService.emitSearchQueryEvent(query);
      this.router.navigate(['/site/search-results']);
    }
  }
}
